module.exports = __webpack_public_path__ + "img/rise.16e4e49a.svg";